<div class="now-decorative-card now-decorative-card-small">
  <h3 class="h5" [attr.id]="'table_termine_heading_' + angebotId" #heading>
    Termine zum Weiterbildungsangebot
  </h3>
  @if (isPhone$ | async) {
    <now-wbsuche-lib-mobile-column-sort
      [angebotId]="angebotId"
      [sortColumn]="(sortColumn$ | async)!"
      [sortDirection]="(sortDirection$ | async)!"
      (sortChanged)="sortChangedFromDropdown($event)"
    ></now-wbsuche-lib-mobile-column-sort>
  }
  @if (anzahlTermine > 0) {
    <table
      class="now-table mb-0"
      [attr.aria-labelledby]="'table_termine_heading_' + angebotId"
      [attr.id]="'angebot_termine_tabelle_' + angebotId"
    >
      <caption>
        Spalten mit Schaltern im Tabellenkopf sind sortierbar.
      </caption>
      <thead class="now-table-header">
        <tr class="now-table-header-row">
          <ng-template
            *ngTemplateOutlet="
              header;
              context: {
                column: SortableColumn.BEGINN,
                name: 'Beginn'
              }
            "
          ></ng-template>
          <ng-template
            *ngTemplateOutlet="
              header;
              context: {
                column: SortableColumn.DAUER,
                name: 'Dauer'
              }
            "
          ></ng-template>
          <ng-template
            *ngTemplateOutlet="
              header;
              context: {
                column: SortableColumn.ORT,
                name: 'Ort'
              }
            "
          ></ng-template>

          @if ((isDesktop$ | async) === true) {
            <ng-template
              *ngTemplateOutlet="
                header;
                context: {
                  column: SortableColumn.UNTERRICHTS_FORM,
                  name: 'Unterrichtsform'
                }
              "
            ></ng-template>
          }
          @if (isDesktop$ | async) {
            <ng-template
              *ngTemplateOutlet="
                header;
                context: {
                  column: SortableColumn.UNTERRICHTS_ZEIT,
                  name: 'Unterrichtszeit'
                }
              "
            ></ng-template>
          }
          @if (isDesktop$ | async) {
            <ng-template
              *ngTemplateOutlet="
                header;
                context: {
                  column: SortableColumn.KOSTEN,
                  name: 'Kosten'
                }
              "
            ></ng-template>
          }
          <th scope="col" class="now-table-header-cell">Details</th>
        </tr>
      </thead>
      <tbody>
        @for (termin of termineWithDuration$ | async; track termin; let index = $index) {
          <tr tabindex="-1" class="now-table-body-row" (click)="selectTermin($event, termin)">
            <td class="now-table-body-cell" data-head="Beginn">
              @if (termin.beginn) {
                {{ termin.beginn | date }}
              }
              @if (!termin.ende && !termin.beginn) {
                {{ REGELMAESSIGER_START }}
              }
            </td>
            <td class="now-table-body-cell" data-head="Dauer">
              <now-wbsuche-lib-dauer-anzeige [termin]="termin"></now-wbsuche-lib-dauer-anzeige>
            </td>
            <td class="now-table-body-cell" data-head="Ort">
              {{ termin.adresse?.ort || 'ortsunabhängig' }}
            </td>
            @if (isDesktop$ | async) {
              <td class="now-table-body-cell" data-head="Unterrichtsform">
                {{ termin?.unterrichtsform?.bezeichnung || KEINE_ANGABE }}
              </td>
            }
            @if (isDesktop$ | async) {
              <td class="now-table-body-cell" data-head="Unterrichtszeit">
                {{ termin?.unterrichtszeit?.bezeichnung || KEINE_ANGABE }}
              </td>
            }
            @if (isDesktop$ | async) {
              <td class="now-table-body-cell" data-head="Kosten" class="now-table-body-cell">
                @if (termin?.kostenWert === Kosten.KEINE_ANGABE) {
                  {{ KEINE_ANGABE }}
                } @else if (termin.kostenWert === Kosten.PREISVERHANDELTE_MASSNAHME) {
                  <!-- Nichts -->
                } @else {
                  <span class="sr-only">{{ termin?.kosten?.ariaLabel }}</span>
                  <span aria-hidden="true">
                    {{ termin?.kosten?.bezeichnung || KEINE_ANGABE }}
                    {{ termin.kostenWaehrung }}
                  </span>
                }
              </td>
            }
            <td class="now-table-body-cell" data-head="Details">
              @if (isNowWbSuche) {
                @if (termin?.quelle && termin?.quelle?.detailsLink) {
                  <a
                    [id]="'details_' + termin.id"
                    [href]="termin.quelle?.detailsLink"
                    class="now-link-secondary now-icon now-icon-arrow-square-out"
                    (click)="selectTermin($event, termin)"
                    ><span class="sr-only">{{ terminName(termin, index) }}&nbsp;</span>
                    anzeigen
                  </a>
                } @else {
                  <a
                    [id]="'details_' + termin.id"
                    [routerLink]="['/termin/' + termin.id]"
                    queryParamsHandling="preserve"
                    class="now-link-secondary now-icon now-icon-arrow-right-after"
                    (click)="selectTermin($event, termin)"
                    ><span class="sr-only">{{ terminName(termin, index) }}&nbsp;</span>
                    anzeigen
                  </a>
                }
              } @else {
                @if (termin?.quelle && termin?.quelle?.detailsLink) {
                  <button
                    [id]="'details_' + termin.id"
                    class="btn-as-link now-icon now-icon-arrow-square-out"
                    (click)="selectTermin($event, termin)"
                  >
                    <span class="sr-only">{{ terminName(termin, index) }}&nbsp;</span>
                    anzeigen
                  </button>
                } @else {
                  <button
                    [id]="'details_' + termin.id"
                    class="btn-as-link now-icon now-icon-arrow-right-after"
                    (click)="selectTermin($event, termin)"
                  >
                    <span class="sr-only">{{ terminName(termin, index) }}&nbsp;</span>
                    anzeigen
                  </button>
                }
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  } @else {
    Keine Termine vorhanden
  }

  @if (anzahlTermine) {
    <now-wbsuche-lib-termin-tabelle-paginierung
      [angebotId]="angebotId"
      [totalItems]="anzahlTermine!"
      [pageSize]="pageSize"
      [currentPage]="(currentPage$ | async) ?? 1"
      (currentPageChange)="currentPageChange($event)"
      class="d-block mt-3"
    ></now-wbsuche-lib-termin-tabelle-paginierung>
  }
</div>

<ng-template #header let-column="column" let-name="name">
  <th
    scope="col"
    class="now-table-header-cell now-table-header-cell-interactive"
    [attr.aria-sort]="getSortierungForColumn(column)"
    [attr.id]="'header_' + column + '_' + angebotId"
  >
    <button type="button" (click)="sortChanged(column)" [disabled]="termineLoading$ | async">
      <span>{{ name }}</span>
    </button>
  </th>
</ng-template>
